import { render, staticRenderFns } from "./comp_HotspotItem.vue?vue&type=template&id=3b31a288&scoped=true"
import script from "./comp_HotspotItem.vue?vue&type=script&lang=js"
export * from "./comp_HotspotItem.vue?vue&type=script&lang=js"
import style0 from "./comp_HotspotItem.vue?vue&type=style&index=0&id=3b31a288&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b31a288",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
